import React, { useState, useEffect, useRef, useMemo } from "react";
import { useLocation, Link } from "react-router-dom";
import { motion } from "framer-motion";

const WORKS = [
  { id: 1, name: "GreenPlatter iOS App", discription: "- iOS App Development", path: "GreenPlatterApp" },
  { id: 2, name: "GreenPlatter", discription: "- Website Design", path: "GreenPlatter" },
  { id: 3, name: "Health and Wellness Tracker", discription: "- Web-App Front-end Development", path: "HealthandWellnessTracker" },
];

const WorkNavbar = ({ isWorkPage }) => {
  const location = useLocation();

  const [isExpanded, setIsExpanded] = useState(
    () => JSON.parse(localStorage.getItem("isExpanded")) ?? true
  );
  const [query, setQuery] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => {
      const isTypingInInput =
        document.activeElement &&
        ["INPUT", "TEXTAREA"].includes(document.activeElement.tagName);
      if (!isTypingInInput && e.key === "/") {
        e.preventDefault();
        inputRef.current?.focus();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  //  Automatically Expand Menu on the Big Menu Page
  useEffect(() => {
    if (isWorkPage) {
      // monitor changes to the isWorkPage prop.
      setIsExpanded(true); //Expand the menu (setIsExpanded(true)).
      localStorage.setItem("isExpanded", JSON.stringify(true)); //Save this state in localStorage (true).
    }
  }, [isWorkPage]);

  // filter by query (case-insensitive)
  const filteredWorks = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return WORKS;
    return WORKS.filter((w) => w.name.toLowerCase().includes(q));
  }, [query]);

  // highlight matched text
  const Highlight = ({ text, q }) => {
    if (!q) return <>{text}</>;
    const lower = text.toLowerCase();
    const qLower = q.toLowerCase();
    const parts = [];
    let i = 0;
    while (i < text.length) {
      const idx = lower.indexOf(qLower, i);
      if (idx === -1) {
        parts.push(text.slice(i));
        break;
      }
      if (idx > i) parts.push(text.slice(i, idx));
      parts.push(
        <mark key={idx} className="bg-pink/20 rounded">
          {text.slice(idx, idx + q.length)}
        </mark>
      );
      i = idx + q.length;
    }
    return <>{parts}</>;
  };

  const layoutTransition = { layout: { duration: 0.4, ease: [0.33, 1, 0.68, 1] } };

  return (
    <motion.ul
      layout
      transition={layoutTransition}
      className="p-4 space-y-2 pt-0 md:pt-[8rem]"
    >
      {/* --- Search bar --- */}
      <motion.li layout transition={layoutTransition} className="ml-16 mb-2 md:mb-4 hidden md:block">
        <div className="relative">
          <input
            ref={inputRef}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search projects…"
            aria-label="Search projïects"
            className="w-full md:w-72 max-w-sm rounded-xl border-4 text-deep font-extrabold bg-beige border-brown  backdrop-blur px-3 py-2 pr-10 
                 outline-none focus:ring-4 focus:ring-pink placeholder-brown "
          />
          {/* {query && (
            <button
              onClick={() => setQuery("")}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-brown font-extrabold hover:text-black"
              aria-label="Clear search"
            >
              ×
            </button>
          )} */}
        </div>

        {/* count */}
        <div className="ml-2 mt-2 text-xs font-extrabold text-brown">
          {filteredWorks.length} result{filteredWorks.length !== 1 ? "s" : ""}
          {query ? ` for “${query}”` : ""}
        </div>
      </motion.li>

      {filteredWorks.length === 0 && (
        <motion.li layout transition={layoutTransition} className="ml-24 text-sm text-beige py-2">
          No matches. Try another keyword.
        </motion.li>
      )}

      {filteredWorks.map((work) => {
        const workPath = `/work/${work.path}`;
        return (
        <motion.li key={work.id} layout transition={layoutTransition} className="overflow-hidden">
          <Link
            to={workPath}
            onClick={() => {
              setIsExpanded(false);
              localStorage.setItem("isExpanded", JSON.stringify(false));
            }}
            className={`block hover:text-pink text-lightBrown md:p-2 md:pl-[4rem] transition-transform transition-opacity duration-300 ease-out
              transform-gpu will-change-transform ${
                isExpanded
                  ? "text-xl font-bold md:text-6xl"
                  : "hidden md:block md:font-bold md:text-lg"
              } ${
              location.pathname === `/work/${work.path}`
                ? "underline text-pink text-xl font-extrabold"
                : "hover:text-pink"
            }`}
          >
            {/* name with highlight */}
            <Highlight text={work.name} q={query} />
          </Link>

          {/* description */}
          <p
            className={`md:transition-all md:duration-500 md:ease-in-out ${
              isExpanded
                ? "ml-8 md:ml-32 md:text-2xl md:opacity-100 scale-100"
                : "hidden md:block md:ml-24 md:text-sm"
            }`}
          >
            {work.discription}
          </p>
        </motion.li>
        );
      })}
    </motion.ul>
  );
};

export default WorkNavbar;
